import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  VStack,
  Icon,
  Button,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { FaFileContract } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { termsOfService, privacyPolicy } from './TermsContent';

const Terms = () => {
  const {isAuthenticated, getIdTokenClaims} = useAuth0();
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);


  const handleAccept = () => {
    localStorage.setItem('termsAccepted', 'true');
    const returnUrl = sessionStorage.getItem('returnUrl') || '/';
    navigate(returnUrl);
  };
  
  

  return (
    <Flex
      minH="100vh"
      width="100%"
      align="flex-start"
      justify="center"
      bg="white"
      px={4}
      pt={24}
    >
      <Box
        bg="white"
        p={8}
        borderRadius="2xl"
        boxShadow="2xl"
        width="100%"
        maxW="750px"
        textAlign="center"
      >
        <VStack spacing={6}>
          <Icon as={FaFileContract} boxSize={14} color="blue.500" />
          <Heading size="lg" color="gray.800">
            FloWire Terms of Service & Privacy Policy
          </Heading>
          <Text fontSize="md" color="gray.600">
            Please read and accept our Terms before continuing.
          </Text>

          <Box
            p={4}
            bg="white"
            borderRadius="md"
            borderWidth={1}
            maxH="320px"
            overflowY="auto"
            w="100%"
            textAlign="left"
          >
            <Heading as="h3" size="md" mb={2}>
              Terms of Service
            </Heading>
            <Text
              whiteSpace="pre-wrap"
              fontSize="sm"
              lineHeight="tall"
              color="gray.700"
              textAlign="justify"
            >
              {termsOfService}
            </Text>

            <Heading as="h3" size="md" mt={6} mb={2}>
              Privacy Policy
            </Heading>
            <Text
              whiteSpace="pre-wrap"
              fontSize="sm"
              lineHeight="tall"
              color="gray.700"
              textAlign="justify"
            >
              {privacyPolicy}
            </Text>
          </Box>

          <Button
            colorScheme="blue"
            size="md"
            isLoading={loading}
            onClick={handleAccept}
            w="100%"
          >
            I Accept
          </Button>

          {loading && <Spinner size="sm" />}
        </VStack>
      </Box>
    </Flex>
  );
};

export default Terms;
